import type { TranslationKeys } from './en'

const de: TranslationKeys = {
}

export default de
